<main-form-modal>
    <ng-template #customHtmlElements>
        <div>
            <ivr-assignment-user-task-edit-win></ivr-assignment-user-task-edit-win>
        </div>
    </ng-template>
</main-form-modal>